import { render, staticRenderFns } from "./facturasEnvio.vue?vue&type=template&id=1d1f629e&scoped=true&"
import script from "./facturasEnvio.vue?vue&type=script&lang=js&"
export * from "./facturasEnvio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1f629e",
  null
  
)

export default component.exports